import React from 'react'

const ButtonPreview = (props) => {
    const { variant, elementData, localVariables, globalVariables } = props
    console.log('button preview variant', variant)
    let buttonText = 'Button'
    let buttonStyles = {
        backgroundColor: '#000',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'normal',
        border: 'none',
        padding: '10px 20px',
        borderRadius: 8,
        textAlign: 'center',
        pointerEvens: 'none'
    }

    switch (variant.toLowerCase()) {
        case 'primary':
            buttonText = 'Primary Button'
            buttonStyles.backgroundColor = globalVariables.primaryButtonBgColor.value
            buttonStyles.color = globalVariables.primaryButtonFontColor.value
            buttonStyles.fontSize = globalVariables.primaryButtonFontSize.value
            buttonStyles.fontWeight = globalVariables.primaryButtonFontWeight.value
            buttonStyles.paddingTop = globalVariables.primaryButtonPaddingTop.value
            buttonStyles.paddingBottom = globalVariables.primaryButtonPaddingBottom.value
            buttonStyles.paddingLeft = globalVariables.primaryButtonPaddingLeft.value
            buttonStyles.paddingRight = globalVariables.primaryButtonPaddingRight.value
            buttonStyles.borderRadius = globalVariables.primaryButtonBorderRadius.value
            buttonStyles.borderColor = globalVariables.primaryButtonBorderColor.value
            buttonStyles.borderWidth = globalVariables.primaryButtonBorderWidth.value
            buttonStyles.borderStyle = globalVariables.primaryButtonBorderStyle.value
            break
        case 'secondary':
            buttonText = 'Secondary Button'
            buttonStyles.backgroundColor = globalVariables.secondaryButtonBgColor.value
            buttonStyles.color = globalVariables.secondaryButtonFontColor.value
            buttonStyles.fontSize = globalVariables.secondaryButtonFontSize.value
            buttonStyles.fontWeight = globalVariables.secondaryButtonFontWeight.value
            buttonStyles.paddingTop = globalVariables.secondaryButtonPaddingTop.value
            buttonStyles.paddingBottom = globalVariables.secondaryButtonPaddingBottom.value
            buttonStyles.paddingLeft = globalVariables.secondaryButtonPaddingLeft.value
            buttonStyles.paddingRight = globalVariables.secondaryButtonPaddingRight.value
            buttonStyles.borderRadius = globalVariables.secondaryButtonBorderRadius.value
            buttonStyles.borderColor = globalVariables.secondaryButtonBorderColor.value
            buttonStyles.borderWidth = globalVariables.secondaryButtonBorderWidth.value
            buttonStyles.borderStyle = globalVariables.secondaryButtonBorderStyle.value
            break
        case 'tertiary':
            buttonText = 'Tertiary Button'
            buttonStyles.backgroundColor = globalVariables.tertiaryButtonBgColor.value
            buttonStyles.color = globalVariables.tertiaryButtonFontColor.value
            buttonStyles.fontSize = globalVariables.tertiaryButtonFontSize.value
            buttonStyles.fontWeight = globalVariables.tertiaryButtonFontWeight.value
            buttonStyles.paddingTop = globalVariables.tertiaryButtonPaddingTop.value
            buttonStyles.paddingBottom = globalVariables.tertiaryButtonPaddingBottom.value
            buttonStyles.paddingLeft = globalVariables.tertiaryButtonPaddingLeft.value
            buttonStyles.paddingRight = globalVariables.tertiaryButtonPaddingRight.value
            buttonStyles.borderRadius = globalVariables.tertiaryButtonBorderRadius.value
            buttonStyles.borderColor = globalVariables.tertiaryButtonBorderColor.value
            buttonStyles.borderWidth = globalVariables.tertiaryButtonBorderWidth.value
            buttonStyles.borderStyle = globalVariables.tertiaryButtonBorderStyle.value
            break
    }
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                padding: '10px',
                boxSizing: 'border-box',
                border: 'solid 1px var(--neutral-200)',
                borderRadius: 8,
                alignItems: 'center',
                marginBottom: '16px'
            }}
        >
            <button style={buttonStyles}>{buttonText}</button>
        </div>
    )
}

export default ButtonPreview
